import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../assets/icons/Icon';

const TopbarMenuLinks = (props) => {
    const { title, path, icon, onClick, 'data-cy': dataCy } = props;

    return (
        <Link
            className="topbar__link"
            to={path}
            onClick={onClick}
            data-cy={dataCy}
        >
            {icon ? <Icon className="sidebar__link-icon" icon={icon} /> : ''}
            <span className="topbar__link-icon" />
            <p className="topbar__link-title">{title}</p>
        </Link>
    );
};

export default TopbarMenuLinks;
